import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efef0e5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 p-mt-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Video for approval for CPM companies:", -1))
const _hoisted_3 = { class: "p-d-flex flex-gap" }
const _hoisted_4 = { class: "p-flex-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "By Day", -1))
const _hoisted_6 = { class: "p-d-flex relative" }
const _hoisted_7 = { class: "p-flex-column" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "By Status", -1))
const _hoisted_9 = { class: "p-flex-column" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "By Campaign name", -1))
const _hoisted_11 = { class: "p-flex-column" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "By Author name", -1))
const _hoisted_13 = { class: "p-d-flex" }
const _hoisted_14 = { class: "campaign-name" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "campaign-name" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "campaign-name" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 0,
  class: "campaign-name"
}
const _hoisted_23 = {
  key: 1,
  class: "campaign-name"
}
const _hoisted_24 = {
  key: 0,
  class: "p-flex-column"
}
const _hoisted_25 = { class: "p-d-flex p-justify-between action-block p-mt-3" }
const _hoisted_26 = { class: "p-d-flex p-justify-between action-block p-mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_StatusChip = _resolveComponent("StatusChip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _withDirectives((_openBlock(), _createElementBlock("span", {
            class: "close-date",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.dateFilter = null; _ctx.changeStatusQuery()})
          }, [
            _createTextVNode("X")
          ])), [
            [
              _directive_tooltip,
              'Clear date?',
              void 0,
              { top: true }
            ]
          ]),
          _createVNode(_component_Calendar, {
            maxDate: new Date(),
            modelValue: _ctx.dateFilter,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dateFilter) = $event)),
            selectionMode: "range",
            class: "calendar-item"
          }, null, 8, ["maxDate", "modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.selectedQuery,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedQuery) = $event)),
          options: _ctx.queryesStatus,
          onChange: _ctx.changeStatusQuery,
          optionLabel: "name",
          optionValue: "value",
          placeholder: "Select a status video"
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_InputText, {
          type: "text",
          onInput: _ctx.processChange,
          modelValue: _ctx.filterCampaignName,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterCampaignName) = $event)),
          placeholder: "Enter Campaign Name"
        }, null, 8, ["onInput", "modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_InputText, {
          type: "text",
          onInput: _ctx.processChange,
          modelValue: _ctx.ownerName,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ownerName) = $event)),
          placeholder: "Enter Author Name"
        }, null, 8, ["onInput", "modelValue"]),
        _createVNode(_component_Dropdown, {
          modelValue: _ctx.selectedOwnerType,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedOwnerType) = $event)),
          onChange: _ctx.processChange,
          options: [{ value: 'creator', title: 'By Creator name'}, { value: 'agencyOwner', title: 'By Agency name'}],
          optionLabel: "title",
          optionValue: "value",
          placeholder: "Select a user type"
        }, null, 8, ["modelValue", "onChange"])
      ])
    ]),
    _createVNode(_component_DataTable, {
      value: _ctx.contentNeedActionAdmin,
      responsiveLayout: "scroll",
      class: "p-mt-6 w-75 w-100"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "createdAt",
          header: "Upload Date",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formatDate(data?.createdAt)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "title",
          header: "Title",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_router_link, {
              to: { name: 'content-item', params: { itemID: data?.id || data?._id  } },
              class: "p-d-flex p-align-center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: data?.previewPhoto,
                  alt: "preview video photo",
                  class: "photo"
                }, null, 8, _hoisted_15),
                _createElementVNode("span", _hoisted_16, _toDisplayString(data?.title), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "statusAccept",
          header: "Status",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            (data?.statusAccept)
              ? (_openBlock(), _createBlock(_component_StatusChip, {
                  key: 0,
                  status: data?.statusAccept,
                  class: "p-mb-2"
                }, null, 8, ["status"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "campaignId.name",
          header: "For Campaign",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_router_link, {
              to: { name: 'campaign', params: { campaignID: data?.campaignId?.id || data?.campaignId[0]?.id } },
              class: "p-d-flex p-align-center"
            }, {
              default: _withCtx(() => [
                (data?.campaignId[0]?.photo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: data?.campaignId?.photo || data?.campaignId[0]?.photo,
                      alt: "campaign photo",
                      class: "photo"
                    }, null, 8, _hoisted_17))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_18, _toDisplayString(data?.campaignId?.name || data?.campaignId[0]?.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "channelId",
          header: "Author Type",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            (data?.channelId)
              ? (_openBlock(), _createElementBlock("b", _hoisted_19, "Agency Owner"))
              : _createCommentVNode("", true),
            (!data?.channelId && data?.owner?.length)
              ? (_openBlock(), _createElementBlock("b", _hoisted_20, "Creator"))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "owner",
          header: "Author",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_router_link, {
              to: {
                  name: 'creator',
                  params: { creatorID: data?.owner?.id || data?.owner[0]?.id || data?.owner?._id || data?.owner[0]?._id,
                } },
              class: "p-d-flex p-align-center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: data?.owner?.profile?.photo || data?.owner[0]?.profile?.photo,
                  alt: "preview user photo",
                  class: "photo"
                }, null, 8, _hoisted_21),
                (data?.channelId)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(data?.owner?.agencyData?.name || data?.owner[0]?.agencyData?.name), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(data?.owner?.name || data?.owner[0]?.name), 1))
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "action",
          header: "Actions",
          sortable: false
        }, {
          body: _withCtx(({ data }) => [
            (data?.statusAccept === 'pending')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createVNode(_component_Button, {
                    class: "button-see-content p-mr-2",
                    label: "Approve",
                    onClick: ($event: any) => {_ctx.seeApproveReason = !_ctx.seeApproveReason; _ctx.currentApproveVideoId = data?.id || data?._id}
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    class: "button-see-content",
                    label: "Reject",
                    onClick: ($event: any) => {_ctx.seeRejectReason = !_ctx.seeRejectReason; _ctx.currentRejectVideoId = data?.id || data?._id}
                  }, null, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            (data?.statusAccept === 'rejected')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" Reason: " + _toDisplayString(data?.reasonReject), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"]),
    (_ctx.seeRejectReason)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          header: "Reject video",
          visible: _ctx.seeRejectReason,
          "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.seeRejectReason) = $event)),
          breakpoints: {'960px': '75vw', '640px': '90vw'},
          style: { width: '50vw' }
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_Button, {
                label: "Cancel",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.seeRejectReason = false)),
                class: "p-button-text no"
              }),
              _createVNode(_component_Button, {
                label: "Save",
                icon: "pi pi-check",
                class: "yes",
                disabled: _ctx.loadingState,
                onClick: _ctx.rejectVideo
              }, null, 8, ["disabled", "onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_TextArea, {
              rows: "15",
              placeholder: "Reject reason",
              modelValue: _ctx.rejectReason,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.rejectReason) = $event)),
              style: {"width":"80%"},
              class: "p-mr-3 search-input"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true),
    (_ctx.seeApproveReason)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 1,
          header: "Approve video",
          visible: _ctx.seeApproveReason,
          "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.seeApproveReason) = $event)),
          breakpoints: {'960px': '75vw', '640px': '90vw'},
          style: { width: '50vw' }
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_Button, {
                label: "Cancel",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.seeApproveReason = false)),
                class: "p-button-text no"
              }),
              _createVNode(_component_Button, {
                label: "Save",
                icon: "pi pi-check",
                class: "yes",
                disabled: _ctx.loadingState,
                onClick: _ctx.approveVideo
              }, null, 8, ["disabled", "onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_TextArea, {
              rows: "15",
              placeholder: "Approve reason",
              modelValue: _ctx.approveReason,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.approveReason) = $event)),
              style: {"width":"80%"},
              class: "p-mr-3 search-input"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}